import React from "react";
import { Box, Typography } from "@material-ui/core";
import ActionDialog from "../../ActionDialog";
import { FormattedHTMLMessage } from "react-intl";

const PERMISSION_DIALOG_TRANSLATION_MAP = {
  CHANGE_AGENT: "app.enuns.permissions.CHANGE_AGENT",
  CLEAR_AGENT: "app.enuns.permissions.CLEAR_AGENT",
  PROMOTE_TO_AGENT: "app.enuns.permissions.PROMOTE_TO_AGENT",
  DEMOTE_FROM_AGENT: "app.enuns.permissions.DEMOTE_FROM_AGENT",
  RESET_AGREEMENT_STATUS: "app.enuns.permissions.RESET_AGREEMENT_STATUS",
  EDIT_AGREEMENT_JOB_TITLE: "app.enuns.permissions.EDIT_AGREEMENT_JOB_TITLE",
  EDIT_AGREEMENT_CLASS: "app.enuns.permissions.EDIT_AGREEMENT_CLASS",
  EDIT_AGREEMENT_CLASS_LOWER_LEVEL: "app.enuns.permissions.EDIT_AGREEMENT_CLASS_LOWER_LEVEL",
  EDIT_AGREEMENT_MONTHLY_COMMISSION: "app.enuns.permissions.EDIT_AGREEMENT_MONTHLY_COMMISSION",
  EDIT_AGREEMENT_MONTHLY_COMMISSION_LOWER_LEVEL: "app.enuns.permissions.EDIT_AGREEMENT_MONTHLY_COMMISSION_LOWER_LEVEL",
  EDIT_AGREEMENT_ONE_TIME_COMMISSION: "app.enuns.permissions.EDIT_AGREEMENT_ONE_TIME_COMMISSION",
  EDIT_AGREEMENT_ONE_TIME_COMMISSION_LOWER_LEVEL: "app.enuns.permissions.EDIT_AGREEMENT_ONE_TIME_COMMISSION_LOWER_LEVEL",
  EDIT_AGREEMENT_LIMIT: "app.enuns.permissions.EDIT_AGREEMENT_LIMIT",
  EDIT_AGREEMENT_LIMIT_LOWER_LEVEL: "app.enuns.permissions.EDIT_AGREEMENT_LIMIT_LOWER_LEVEL",
  EDIT_AGREEMENT_INVESTMENT: "app.enuns.permissions.EDIT_AGREEMENT_INVESTMENT",
  EDIT_AGREEMENT_VISIBILITY: "app.enuns.permissions.EDIT_AGREEMENT_VISIBILITY",
  EDIT_AGREEMENT_PERMISSIONS: "app.enuns.permissions.EDIT_AGREEMENT_PERMISSIONS",
  ARCHIVE: "app.enuns.permissions.ARCHIVE",
  EDIT_RECOMMENDER: "app.enuns.permissions.EDIT_RECOMMENDER",
  REMOVE_RECOMMENDER: "app.enuns.permissions.REMOVE_RECOMMENDER",
  EDIT_INVITATIONS: "app.enuns.permissions.EDIT_INVITATIONS",
};

const DisplayPermissionsDialog = ({ open, handleCloseDialog, user }) => {
  return (
    <ActionDialog
      title="app.manager.permissions"
      open={open}
      enableConfirmButton={false}
      onClose={handleCloseDialog}
      maxWidth="xs"
    >
      <Box
        component={"ul"}
        style={{
          listStyle: "disc",
          paddingLeft: 16,
          margin: 0,
        }}
      >
        {user?.contractAgent?.permissions?.length ? (
          user.contractAgent.permissions.map((permission, index) => {
            const translationId = PERMISSION_DIALOG_TRANSLATION_MAP[permission.name] || `app.enuns.permissions.${permission.name}`;

            return (
              <Typography
                key={permission.id || index}
                variant="body2"
                component="li"
                style={{ marginBottom: 4 }}
              >
                <FormattedHTMLMessage
                  id={translationId}
                  defaultMessage={permission.name}
                />
              </Typography>
            );
          })
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            component={"li"}
          >
            <FormattedHTMLMessage id="app.management.permissions.NONE" />
          </Typography>
        )}
      </Box>
    </ActionDialog>
  );
};

export default DisplayPermissionsDialog;
